__turbopack_context__.v({
  "className": "xKNaxa_className",
  "variable": "xKNaxa_variable",
});
